import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://c5086362a255406c9bb8e8247923c299@o1186798.ingest.sentry.io/6306619",
        // An array of strings or regexps that'll be used to ignore specific errors based on their type/message
        ignoreErrors: [/isTrigger, jQuery/],
    });
    window.Sentry = Sentry
}